export const ALERT_SETTING_SLICE_NAME = 'alerts/alertSetting'
export const PANEL_EMAIL_SETTING_ID = 'PANEL_EMAIL_SETTING_ID'

export const SETTING_KEYS = {
  EMAIL: 'isAlertEmail',
  EMAIL_DIGEST: 'isAlertEmailDigest',
  INDUSTRY: 'isIndustryAlerts',
  INDUSTRY_EMAIL: 'industryAlertsSendEmails',
  MACRO: 'isMacroeconomicAlerts',
  MACRO_EMAIL: 'macroeconomicAlertsSendEmails',
  PROFILE: 'listAlertSettingsProfile',
}

export const TABLE_COL = {
  CHECKBOX: 'CHECKBOX',
  PROFILE_NAME: 'profileName',
  PORTFOLIO: 'numberOfPortfolios',
  ENABLE_EMAIL: 'enableEmail',
  TOOLS: 'TOOLS',
}
